import { formatPhoneNumber } from 'utils/phoneNumber';

export const CustomerDisplayNameType = {
  NAME: 0,
  EMAIL: 1,
  PHONE_NUMBER: 2,
};

const DEFAULT_CUSTOMER_DISPLAY_NAME_PRECENDENCE_LIST = [
  CustomerDisplayNameType.NAME,
  CustomerDisplayNameType.EMAIL,
  CustomerDisplayNameType.PHONE_NUMBER,
];

/**
 * Builds the customer display name from the customer object and customer
 * display name precedence list. By default, it will try to return the customer
 * name first, then email address, and then phone number. If none of the
 * information is present, returns `Unknown name`.
 *
 * @param customer The customer to get the display name for.
 * @param precedenceList The precedence list for the customer display name.
 * @returns The customer display name.
 */
export function getCustomerDisplayName(
  customer,
  precedenceList = DEFAULT_CUSTOMER_DISPLAY_NAME_PRECENDENCE_LIST
) {
  for (const customerDisplayNameType of precedenceList) {
    switch (customerDisplayNameType) {
      case CustomerDisplayNameType.NAME: {
        if (customer?.familyName && customer?.givenName) {
          return `${customer.givenName} ${customer.familyName}`;
        } else if (customer?.givenName) {
          return customer.givenName;
        } else if (customer?.familyName) {
          return customer.familyName;
        }
        break;
      }

      case CustomerDisplayNameType.EMAIL: {
        if (customer?.emailAddress) {
          return customer.emailAddress;
        }
        break;
      }

      case CustomerDisplayNameType.PHONE_NUMBER: {
        if (customer?.phoneNumber) {
          return formatPhoneNumber(customer.phoneNumber);
        }
        break;
      }

      default:
        break;
    }
  }

  return 'Unknown name';
}
